import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { userInformation as handleGetUser } from 'auth'

const initialState = {
  loading: false,
  error: false,
  errorMsg: '',
  user: null
}

export const slice = createSlice({
  name: 'user',
  initialState,
  extraReducers: (builder) => {
    // for get user
    builder.addCase(getUserInfo.pending, (state, action) => {
      state['loading'] = true
      state['error'] = false
      state['errorMsg'] = ''
    })
    builder.addCase(getUserInfo.fulfilled, (state, action) => {
      state['loading'] = false
      state.user = action.payload
    })
    builder.addCase(getUserInfo.rejected, (state, action) => {
      state['loading'] = false
      state['error'] = true
      state['errorMsg'] =
        action.error?.message || 'Oops! Get User Info Error occurred, please try again later'
    })
  }
})

// export const {getUser } = slice.actions

//get user
export const getUserInfo = createAsyncThunk('user/getUserInfo', async () => {
  return await handleGetUser()
})

// Selectors

export const selectUserData = (state) => state.user

export default slice.reducer
